var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestMilesTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.275 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "request_miles") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.575,14.64a4.061,4.061,0,1,0,4.06-4.061A4.064,4.064,0,0,0,10.575,14.64Zm4.06-2.561a2.561,2.561,0,1,1-2.56,2.561A2.564,2.564,0,0,1,14.635,12.079Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.62,28.5H20.487V25.137a5.7,5.7,0,0,0-5.847-5.526,5.706,5.706,0,0,0-5.857,5.526V28.5H3.65a.75.75,0,0,0,0,1.5H9.522l.011,0,.011,0H19.726l.011,0,.011,0H25.62a.75.75,0,0,0,0-1.5ZM10.283,25.137a4.206,4.206,0,0,1,4.357-4.026,4.2,4.2,0,0,1,4.347,4.026V28.5h-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.972,0H2.3A2.305,2.305,0,0,0,0,2.3V13.37a2.3,2.3,0,0,0,2.3,2.3h1.32l3.686,3.687a.75.75,0,0,0,.53.219.738.738,0,0,0,.287-.057.747.747,0,0,0,.463-.693V15.672h.152a.75.75,0,0,0,0-1.5h-.9a.75.75,0,0,0-.75.75v2.1L4.463,14.392a.747.747,0,0,0-.53-.22H2.3a.8.8,0,0,1-.8-.8V2.3a.8.8,0,0,1,.8-.8H26.972a.8.8,0,0,1,.8.8V13.37a.8.8,0,0,1-.8.8H20.53a.75.75,0,0,0,0,1.5h6.442a2.3,2.3,0,0,0,2.3-2.3V2.3A2.305,2.305,0,0,0,26.972,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.12,6.811a1.026,1.026,0,1,0,1.025,1.025A1.025,1.025,0,0,0,11.12,6.811Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.663,7.836a1.026,1.026,0,1,0-1.025,1.026A1.025,1.025,0,0,0,15.663,7.836Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.181,7.836a1.025,1.025,0,1,0-1.025,1.026A1.025,1.025,0,0,0,19.181,7.836Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestMilesTeal);
export default __webpack_public_path__ + "static/media/request_miles_teal.90f7c5b08ca263a4db1619194bb7f004.svg";
export { ForwardRef as ReactComponent };